import Annotation from "./annotation";
import { setFontStyle, setLineStyle } from "../canvasUtils";

export default class ThicknessMapPalette extends Annotation {
  constructor() {
    super();

    this.gradient = [];
    this.min = 0;
    this.max = 500;
    this.step = 100;

    this.lineWidth = 1;
    this.color = "white";
    this.fontColor = "white";
    this.font = "12px Calibri";
    this.baseline = "middle";
    
    this.canvasSize = null;
  }

  draw(ctx) {
    if (!this.canvasSize || !this.gradient || !this.gradient.length) return;
    let { x, y, gradientWidth, gradientHeight } = this.calculatePositions();
    this.drawScale(ctx, x, y, gradientWidth, gradientHeight);
    this.drawGradient(ctx, x, y, gradientWidth, gradientHeight);
  }

  calculatePositions() {
    let gradientHeight = Math.min(this.canvasSize.h - 30, 175);
    let gradientWidth = 15;
    let x = 0;
    let y = (this.canvasSize.h - gradientHeight) / 2;
    return { x, y, gradientWidth, gradientHeight };
  }

  drawGradient(ctx, x, y, w, h) {
    let gradient = ctx.createLinearGradient(0, y, 0, y + h);
    for (let i = 0; i < this.gradient.length; i++) {
      let stop = this.gradient[i];
      gradient.addColorStop(1 - stop[0], "#" + stop[1].toString(16).padStart(6, "0"));
    }
    ctx.fillStyle = gradient;
    ctx.fillRect(x, y, w, h);
  }

  drawScale(ctx, x, y, w, h) {
    setFontStyle(ctx, this);
    ctx.beginPath();
    ctx.moveTo(x + w + 5, y);
    ctx.lineTo(x + w + 5, y + h);
    let stepHeight = this.step / (this.max - this.min) * h;
    let textY = y + h;
    let currentStep = this.min;
    while (textY >= y - 5) {
      this.drawScaleText(ctx, currentStep, x + w + 5, textY);
      textY -= stepHeight;
      currentStep += this.step;
    }
    ctx.closePath();
    setLineStyle(ctx, this);
    ctx.stroke();
  }

  drawScaleText(ctx, step, x, y) {
    ctx.moveTo(x, y);
    ctx.lineTo(x + 5, y);
    let text = step || "0 µm";
    ctx.fillText(text, x + 10, y);
  }

  updateGradient(gradient) {
    this.gradient = gradient;
    this.signalReady();
  }
}